export default "__VITE_ASSET__WpC3m$aY__"